/* Interactive grouped model cards.
   Data: <feed>/feed  ->  { models:[{ key,name,brand,colorways,fromPrice, variants:[{title,image,handle,price}] }] }
   Per-colorway sizes/box-condition/variant-ids come live from Shopify's /products/<handle>.js
   (always-fresh inventory), so add-to-cart is correct even as stock changes.
   Flow: tap a colorway photo -> its sizes (+ lids) -> tap a size -> add to cart. */
(function () {
  "use strict";
  var containers = document.querySelectorAll("[data-model-cards]");
  if (!containers.length) return;

  var pcache = {}; // handle -> product.js (or null if it failed to load)

  function money(cents) {
    var n = cents / 100;
    return "$" + (n % 1 ? n.toFixed(2) : String(n));
  }
  function dollars(n) { return "$" + (n % 1 ? n.toFixed(2) : String(n)); }
  function el(tag, cls, html) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (html != null) e.innerHTML = html;
    return e;
  }
  function esc(s) { return (s || "").replace(/[&<>"]/g, function (c) { return ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" })[c]; }); }

  // strip the model name + size/age noise from a colorway title -> a short colour label
  function colourLabel(title, modelName) {
    var t = " " + (title || "").toLowerCase() + " ";
    (modelName || "").toLowerCase().split(" ").forEach(function (w) { if (w.length > 1) t = t.replace(" " + w + " ", " "); });
    t = t.replace(/\b(men's|women's|mens|womens|gs|ps|td|psv|little kid|big kid|toddler|youth|infant|brand new|new)\b/g, " ")
         .replace(/[()'"./]/g, " ").replace(/\s+/g, " ").trim();
    return t || "colourway";
  }

  function optionIndexes(product) {
    var opts = (product.options || []).map(function (o) { return (typeof o === "string" ? o : o.name) || ""; });
    var sizeIdx = -1, boxIdx = -1;
    opts.forEach(function (name, i) {
      var dn = name.toLowerCase();
      if (dn.indexOf("size") >= 0 && sizeIdx < 0) sizeIdx = i;
      else if (dn.indexOf("box") >= 0 || dn.indexOf("condition") >= 0 || dn.indexOf("lid") >= 0) boxIdx = i;
    });
    if (sizeIdx < 0 && opts.length === 1) sizeIdx = 0; // single-axis fallthrough
    return { sizeIdx: sizeIdx, boxIdx: boxIdx, names: opts };
  }
  // friendly lid label from a raw box-condition value
  function lidLabel(v) {
    var s = (v || "").toLowerCase();
    if (/full|complete|with|good|og all/.test(s)) return "with lid";
    if (/missing|no lid|without|damag|lidless/.test(s)) return "without lid";
    return v;
  }

  function buildCard(model) {
    var card = el("article", "model-card");
    card.setAttribute("data-key", model.key);
    var v0 = model.variants[0] || {};

    // hero image links to the SELECTED colorway's product page (selectColorway
    // retargets the href); swatch taps still drive the on-card buy flow
    var media = el("div", "mc-media");
    var link = el("a", "mc-media-link");
    link.href = "/products/" + encodeURIComponent(v0.handle || "");
    link.setAttribute("aria-label", "view " + (model.name || "product"));
    var img = el("img");
    img.loading = "lazy"; img.src = v0.image || ""; img.alt = "";
    link.appendChild(img);
    media.appendChild(link);
    card.appendChild(media);

    var info = el("div", "mc-info");
    info.appendChild(el("div", "mc-name", esc(model.name)));
    var price = el("div", "mc-price", (model.colorways > 1 ? "from " : "") + dollars(model.fromPrice));
    info.appendChild(price);
    var cwcount = el("div", "mc-count", model.colorways + (model.colorways === 1 ? " colour" : " colours"));
    info.appendChild(cwcount);
    card.appendChild(info);

    // colorway swatches
    var strip = el("div", "mc-cw");
    model.variants.forEach(function (v, i) {
      var b = el("button", "mc-swatch" + (i === 0 ? " is-active" : ""));
      b.type = "button";
      b.title = colourLabel(v.title, model.name);
      var si = el("img"); si.loading = "lazy"; si.src = v.image || ""; si.alt = b.title;
      b.appendChild(si);
      b.addEventListener("click", function () { selectColorway(card, model, i); });
      strip.appendChild(b);
    });
    card.appendChild(strip);

    // buy zone (revealed after a colorway is chosen)
    var buy = el("div", "mc-buy");
    buy.hidden = true;
    buy.innerHTML =
      '<div class="mc-lids" hidden></div>' +
      '<div class="mc-sizes"></div>' +
      '<div class="mc-status" aria-live="polite"></div>' +
      '<button type="button" class="mc-add btn block dark" disabled>select a size</button>';
    card.appendChild(buy);

    card._model = model;
    card._sel = { i: 0, size: null, box: null };
    return card;
  }

  function selectColorway(card, model, i) {
    card._sel = { i: i, size: null, box: null };
    var v = model.variants[i];
    card.querySelectorAll(".mc-swatch").forEach(function (s, si) { s.classList.toggle("is-active", si === i); });
    var img = card.querySelector(".mc-media img"); if (img) img.src = v.image || img.src;
    var lk = card.querySelector(".mc-media-link"); if (lk && v.handle) lk.href = "/products/" + encodeURIComponent(v.handle);
    var price = card.querySelector(".mc-price"); if (price) price.textContent = dollars(v.price);
    var buy = card.querySelector(".mc-buy"); buy.hidden = false;
    var status = card.querySelector(".mc-status"); status.textContent = "";
    var sizes = card.querySelector(".mc-sizes"); sizes.innerHTML = '<span class="mc-loading">loading sizes…</span>';
    card.querySelector(".mc-lids").hidden = true;
    var addBtn = card.querySelector(".mc-add"); addBtn.disabled = true; addBtn.textContent = "select a size";

    loadProduct(v.handle).then(function (product) {
      if (card._sel.i !== i) return; // user moved on
      if (!product) { sizes.innerHTML = ""; status.textContent = "unavailable — tap another colour"; return; }
      renderBuy(card, product);
    });
  }

  function loadProduct(handle) {
    if (handle in pcache) return Promise.resolve(pcache[handle]);
    return fetch("/products/" + encodeURIComponent(handle) + ".js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; })
      .then(function (p) { pcache[handle] = p; return p; });
  }

  function renderBuy(card, product) {
    var idx = optionIndexes(product);
    var variants = product.variants || [];
    card._product = product;
    card._idx = idx;

    // box-condition (lids) chips, if that axis exists
    var lidsWrap = card.querySelector(".mc-lids");
    lidsWrap.innerHTML = ""; lidsWrap.hidden = true;
    if (idx.boxIdx >= 0) {
      var boxVals = [];
      variants.forEach(function (v) { var bv = v.options[idx.boxIdx]; if (bv && boxVals.indexOf(bv) < 0) boxVals.push(bv); });
      if (boxVals.length > 1) {
        lidsWrap.hidden = false;
        lidsWrap.appendChild(el("span", "mc-axis-label", "box"));
        boxVals.filter(function (bv) {
          return variants.some(function (v) { return v.options[idx.boxIdx] === bv && v.available; });
        }).forEach(function (bv, k) {
          var b = el("button", "mc-lid", esc(lidLabel(bv)));
          b.type = "button"; b.setAttribute("data-box", bv);
          b.addEventListener("click", function () {
            card._sel.box = bv; card._sel.size = null;
            lidsWrap.querySelectorAll(".mc-lid").forEach(function (x) { x.classList.remove("is-active"); });
            b.classList.add("is-active");
            renderSizes(card);
          });
          lidsWrap.appendChild(b);
        });
        // default to first in-stock box
        var firstStock = boxVals.filter(function (bv) { return variants.some(function (v) { return v.options[idx.boxIdx] === bv && v.available; }); })[0] || boxVals[0];
        card._sel.box = firstStock;
        var db = lidsWrap.querySelector('[data-box="' + (window.CSS && CSS.escape ? CSS.escape(firstStock) : firstStock) + '"]');
        if (db) db.classList.add("is-active");
      } else if (boxVals.length === 1) {
        card._sel.box = boxVals[0];
      }
    }
    renderSizes(card);
  }

  function renderSizes(card) {
    var product = card._product, idx = card._idx, variants = product.variants || [];
    var sizes = card.querySelector(".mc-sizes");
    var addBtn = card.querySelector(".mc-add");
    var status = card.querySelector(".mc-status");
    sizes.innerHTML = ""; status.textContent = "";
    addBtn.disabled = true; addBtn.textContent = "select a size";
    card._sel.size = null;

    if (idx.sizeIdx < 0) {
      // one-size product: single available variant
      var only = variants.filter(function (v) { return v.available; })[0] || variants[0];
      if (only) { card._sel.variant = only.id; addBtn.disabled = !only.available; addBtn.textContent = only.available ? "add to cart" : "sold out"; }
      return;
    }

    var order = ["s", "m", "l", "xl", "xxl"];
    var seen = {}, list = [];
    variants.forEach(function (v) {
      var sz = v.options[idx.sizeIdx];
      if (sz == null || seen[sz]) return; seen[sz] = 1;
      var matchBox = card._sel.box == null || v.options[idx.boxIdx] === card._sel.box;
      var avail = variants.some(function (w) { return w.options[idx.sizeIdx] === sz && (card._sel.box == null || w.options[idx.boxIdx] === card._sel.box) && w.available; });
      list.push({ sz: sz, avail: avail && matchBox !== false });
    });
    // size-chart order via the shared comparator when theme.js is present; fallback keeps
    // the old apparel-letters/numeric sort
    if (window.staackedSortSizes) {
      var pos = {};
      window.staackedSortSizes(list.map(function (it) { return it.sz; }))
        .forEach(function (v, i) { if (pos[v] == null) pos[v] = i; });
      list.sort(function (a, b) { return pos[a.sz] - pos[b.sz]; });
    } else list.sort(function (a, b) {
      var ai = order.indexOf(String(a.sz).toLowerCase()), bi = order.indexOf(String(b.sz).toLowerCase());
      if (ai >= 0 || bi >= 0) return (ai < 0 ? 99 : ai) - (bi < 0 ? 99 : bi);
      return (parseFloat(a.sz) || 0) - (parseFloat(b.sz) || 0);
    });

    list = list.filter(function (it) { return it.avail; });
    if (!list.length) { status.textContent = "no sizes available"; return; }
    list.forEach(function (it) {
      var b = el("button", "mc-size", esc(String(it.sz).toLowerCase()));
      b.type = "button";
      b.addEventListener("click", function () {
        card._sel.size = it.sz;
        sizes.querySelectorAll(".mc-size").forEach(function (x) { x.classList.remove("is-active"); });
        b.classList.add("is-active");
        var variant = resolveVariant(card);
        if (variant) { card._sel.variant = variant.id; addBtn.disabled = false; addBtn.textContent = "add to cart"; }
        else { addBtn.disabled = true; addBtn.textContent = "unavailable"; }
      });
      sizes.appendChild(b);
    });
  }

  function resolveVariant(card) {
    var product = card._product, idx = card._idx;
    return (product.variants || []).filter(function (v) {
      if (idx.sizeIdx >= 0 && v.options[idx.sizeIdx] !== card._sel.size) return false;
      if (idx.boxIdx >= 0 && card._sel.box != null && v.options[idx.boxIdx] !== card._sel.box) return false;
      return v.available;
    })[0];
  }

  function addToCart(card) {
    var addBtn = card.querySelector(".mc-add");
    var status = card.querySelector(".mc-status");
    var id = card._sel.variant;
    if (!id) return;
    addBtn.disabled = true; addBtn.textContent = "adding…";
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
      .then(function () {
        addBtn.textContent = "added ✓";
        status.innerHTML = '<a href="/cart">view cart →</a>';
        if (window.staackedRefreshCart) window.staackedRefreshCart();
        setTimeout(function () { addBtn.disabled = false; addBtn.textContent = "add to cart"; }, 1800);
      })
      .catch(function () { addBtn.disabled = false; addBtn.textContent = "try again"; status.textContent = "couldn't add — tap try again"; });
  }

  containers.forEach(function (grid) {
    var base = (grid.getAttribute("data-feed") || "").replace(/\/$/, "");
    var limit = parseInt(grid.getAttribute("data-limit"), 10) || 12;
    var loadMore = grid.getAttribute("data-load-more") === "1";
    var moreBtn = grid.parentElement.querySelector("[data-mc-more]");
    var shown = 0, models = [];

    function paint(n) {
      var frag = document.createDocumentFragment();
      models.slice(shown, shown + n).forEach(function (m) { frag.appendChild(buildCard(m)); });
      grid.appendChild(frag);
      shown += n;
      if (moreBtn) moreBtn.hidden = shown >= models.length;
    }

    grid.addEventListener("click", function (e) {
      var add = e.target.closest(".mc-add");
      if (add && !add.disabled) { addToCart(add.closest(".model-card")); }
    });
    if (moreBtn) moreBtn.addEventListener("click", function () { paint(limit); });

    // query mode (search page): only models where EVERY query word matches brand+name;
    // the whole section stays hidden unless something matches.
    var query = (grid.getAttribute("data-query") || "").toLowerCase().trim();
    var section = grid.closest("[data-mc-query-section]");

    fetch(base + "/feed", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        models = (data.models || []).filter(function (m) { return m.variants && m.variants.length; });
        if (query) {
          var words = query.split(/\s+/).filter(Boolean);
          models = models.filter(function (m) {
            var hay = ((m.brand || "") + " " + (m.name || "")).toLowerCase();
            return words.every(function (w) { return hay.indexOf(w) >= 0; });
          });
          if (!models.length) return; // leave the section hidden
          if (section) section.hidden = false;
        }
        grid.innerHTML = "";
        if (!models.length) { grid.innerHTML = '<p class="empty">no models yet.</p>'; return; }
        paint(loadMore ? limit : Math.min(limit, models.length));
        if (!loadMore && moreBtn) moreBtn.hidden = true;
      })
      .catch(function () { if (!query) grid.innerHTML = '<p class="empty">couldn\'t load models. <a href="/collections/all">browse all products →</a></p>'; });
  });
})();
